import { glyphs } from'@acos/dh-ikoner/glyphs';


type AcosIconProps = {
    icon?: typeof glyphs[number];
    children?: typeof glyphs[number] | string;
};

function getGlyphId(props: AcosIconProps): typeof glyphs[number] {
    if (props.icon) return props.icon;

    return props.children as typeof glyphs[number];
}


export function AcosIcon({ icon, children, color, style, ...rest }: AcosIconProps & Omit<JSX.IntrinsicElements['i'], 'children' | 'aria-hidden'>) {
    if (color) {
        if (style) {
            style.color = color;
        } else {
            style = { color };
        }
    }
    return <i {...rest} aria-hidden="true" style={style} className={`wsi wsi-${getGlyphId({ icon, children })} ${rest.className ?? ''}`.trim()}></i>;
}
export class IconsList {
    private static _glyphs = Array.from(glyphs).sort();
    static get glyphs() {
        return this._glyphs;
    }
}

